import React, { Component } from 'react';
import DrawerSlideWrapper from './DrawerSlideWrapper';

class MenuFixedCounterSelect extends Component {
  render() {
    const { numDishesSelected, handleSelectDishes, isShown } = this.props;

    return (
      <DrawerSlideWrapper isOpen={isShown} isLeft={true} isMenuSelect={true}>
        <div className="menu-selection-new__select-wrap">
          <div className="menu-selection-new__counter-wrap">
            <p>Choose up to 6 Dishes</p>
            <p>{numDishesSelected} of 6 Selected</p>
          </div>
          <button
            className="new-btn new-btn--full-width new-btn--solid-green"
            onClick={handleSelectDishes}
            disabled={numDishesSelected === 0}
          >
            Select Dishes
          </button>
        </div>
      </DrawerSlideWrapper>
    );
  }
}

export default MenuFixedCounterSelect;



// WEBPACK FOOTER //
// ./src/components/new/MenuFixedCounterSelect.js